import {
  DealerClaimDTO,
  DealerClaimClient_V1,
  DealerClaimSearchDTO,
  CreateClaimDTO,
  CreateClaimLineAttachmentDTO,
  CreateClaimLineDTO,
  CreateClaimLineItemDTO,
  CreateClaimLineMiscChargeDTO,
  CreateaClaimLineNoteDTO,
  ValidationBaseDTO,
  DealerClaimLineAttachmentDTO,
  ExportDTO,
  ReturnLabelDTO,
  AttachmentInfoDTO
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import { ApiHelper } from 'src/utils';

export default class ClaimService {
  private readonly _dealerClaimClient: DealerClaimClient_V1;

  constructor() {
    this._dealerClaimClient = new DealerClaimClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
  }

  public Claims(dealerAccountUid: string, dto: DealerClaimSearchDTO): Promise<Array<DealerClaimDTO>> {
    return this._dealerClaimClient.claims(dto, dealerAccountUid);
  }
  public CreateClaim(dealerAccountUid: string, dto: CreateClaimDTO): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() => this._dealerClaimClient.createClaim(dto, dealerAccountUid));
  }
  public CreateClaimFromRecall(dealerAccountUid: string, dto: CreateClaimDTO): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() =>
      this._dealerClaimClient.createClaimFromRecall(dto, dealerAccountUid)
    );
  }
  public EditClaim(dealerAccountUid: string, dto: DealerClaimDTO): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() => this._dealerClaimClient.editClaim(dto, dealerAccountUid));
  }
  public GetClaimByClaimNumber(dealerAccountUid: string, claimNumber: string): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() =>
      this._dealerClaimClient.getByClaimNumber(dealerAccountUid, claimNumber)
    );
  }
  public CreateClaimLine(dealerAccountUid: string, dto: CreateClaimLineDTO): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() => this._dealerClaimClient.createClaimLine(dto, dealerAccountUid));
  }
  public CreateClaimLineItem(dealerAccountUid: string, dto: CreateClaimLineItemDTO): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() => this._dealerClaimClient.createClaimLineItem(dto, dealerAccountUid));
  }
  public CreateClaimLineMiscCharge(
    dealerAccountUid: string,
    dto: CreateClaimLineMiscChargeDTO
  ): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() =>
      this._dealerClaimClient.createClaimLineMiscCharge(dto, dealerAccountUid)
    );
  }
  public CreateClaimLineAttachment(
    dealerAccountUid: string,
    dto: CreateClaimLineAttachmentDTO
  ): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() =>
      this._dealerClaimClient.createClaimLineAttachment(dto, dealerAccountUid)
    );
  }
  public CreateClaimLineNote(dealerAccountUid: string, dto: CreateaClaimLineNoteDTO): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() => this._dealerClaimClient.createClaimLineNote(dto, dealerAccountUid));
  }
  public SubmitPreAuthorization(dealerAccountUid: string, claimNumber: string): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() =>
      this._dealerClaimClient.submitPreAuthorization(dealerAccountUid, claimNumber)
    );
  }
  public SubmitWorkComplete(dealerAccountUid: string, claimNumber: string): Promise<DealerClaimDTO> {
    return ApiHelper.ParseDTO<DealerClaimDTO>(() =>
      this._dealerClaimClient.submitWorkComplete(dealerAccountUid, claimNumber)
    );
  }
  public DeleteClaimLine(dealerAccountUid: string, id: number): Promise<ValidationBaseDTO> {
    return ApiHelper.ParseDTO<ValidationBaseDTO>(() => this._dealerClaimClient.deleteClaimLine(dealerAccountUid, id));
  }
  public DeleteClaimLineItem(dealerAccountUid: string, id: number): Promise<ValidationBaseDTO> {
    return ApiHelper.ParseDTO<ValidationBaseDTO>(() =>
      this._dealerClaimClient.deleteClaimLineItem(dealerAccountUid, id)
    );
  }
  public DeleteClaimLineMiscCharge(dealerAccountUid: string, id: number): Promise<ValidationBaseDTO> {
    return ApiHelper.ParseDTO<ValidationBaseDTO>(() =>
      this._dealerClaimClient.deleteClaimLineMiscCharge(dealerAccountUid, id)
    );
  }
  public DeleteClaimLineAttachment(dealerAccountUid: string, id: number): Promise<ValidationBaseDTO> {
    return ApiHelper.ParseDTO<ValidationBaseDTO>(() =>
      this._dealerClaimClient.deleteClaimLineAttachment(dealerAccountUid, id)
    );
  }
  public DeleteClaimLineNote(dealerAccountUid: string, id: number): Promise<ValidationBaseDTO> {
    return ApiHelper.ParseDTO<ValidationBaseDTO>(() =>
      this._dealerClaimClient.deleteClaimLineNote(dealerAccountUid, id)
    );
  }
  public GetClaimLineAttachments(
    dealerAccountUid: string,
    claimLineId: number
  ): Promise<Array<DealerClaimLineAttachmentDTO>> {
    return ApiHelper.ParseDTO<Array<DealerClaimLineAttachmentDTO>>(() =>
      this._dealerClaimClient.getClaimLineAttachments(dealerAccountUid, claimLineId)
    );
  }
  public ExportClaim(dealerAccountUid: string, status: string, autoDenied: boolean): Promise<ExportDTO> {
    return this._dealerClaimClient.exportClaimsByStatus(dealerAccountUid, status, autoDenied);
  }
  public CreateReturnLabel(dealerAccountUid: string, dto: ReturnLabelDTO): Promise<ReturnLabelDTO> {
    return ApiHelper.ParseDTO<DealerClaimLineAttachmentDTO>(() =>
      this._dealerClaimClient.createClaimReturnLabel(dto, dealerAccountUid)
    );
  }

  public GetClaimReport(dealerAccountUid: string, claimId: string | null | undefined): Promise<AttachmentInfoDTO> {
    return this._dealerClaimClient.claimReport(dealerAccountUid, claimId);
  }
}
